import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Cliente } from '../api/dto/cliente';
import { BehaviorSubject, Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { Paginador } from '../api/dto/paginacao/paginador';
import { HistoricoCliente } from '../api/dto/historico-cliente';
import { ContaClientes } from '../api/dto/conta-clientes';
import { HttpParamsUtil } from '../util/http-params-util';

@Injectable({
    providedIn: 'root',
})
export class ClienteService {

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'clientes/';

    private clienteSelecionadoSource = new BehaviorSubject<Cliente | null>(null);
    clienteSelecionado$ = this.clienteSelecionadoSource.asObservable();

    selecionarCliente(cliente: Cliente) {
        this.clienteSelecionadoSource.next(cliente);
    }

    limparClienteSelecionado() {
        this.clienteSelecionadoSource.next(null);
    }

    buscarPorId(id?: number): Observable<Cliente> {
        return this.http.get<Cliente>(this.url + id);
    }


    listarClientesPorEmpresaESituacao(empresaId?: number, situacao?: boolean): Observable<Cliente[]> {
        return this.http.get<Cliente[]>(this.url + 'empresa/' + empresaId + '/situacao/' + situacao);
    }

    listarHistoricoClientePorEmpresa(empresaId?: number, clienteId?: number): Observable<HistoricoCliente[]> {
        return this.http.get<HistoricoCliente[]>(this.url + 'empresa/' + empresaId + '/cliente/' + clienteId + '/historico' );
    }

    listarContaClientesPorEmpresa(empresaId?: number, numeroPagina?: number,
        tamanhoPagina?: number, ordenacao?: string, inputBusca?: string): Observable<Paginador<ContaClientes>> {
        
        let params = new HttpParams();
        if(tamanhoPagina) {
            params = params.set('tamanho', tamanhoPagina);
        }
        if(ordenacao) {
            params = params.set('sort', ordenacao);
        }
        if(inputBusca) {
            params = params.set('busca', inputBusca);
        }

        return this.http.get<Paginador<ContaClientes>>(this.url + 'empresa/' + empresaId +
             '/conta/numero-pagina/' + numeroPagina, {params} );
    }

    listarClientesPorEmpresaESituacaoETextoBuscaPaginado(empresaId?: number, situacao?: boolean,
         numeroPagina?: number, tamanhoPagina?: number, ordenacao?: string, inputBusca?: string): Observable<Paginador<Cliente>> {

        const params = HttpParamsUtil.buildHttpParams(
            {
                page: numeroPagina,
                size: tamanhoPagina,
                sort: ordenacao,
                busca: inputBusca,
                situacao: situacao
            }
        )

        
        return this.http.get<Paginador<Cliente>>(`${this.url}empresa/${empresaId}/paginado`, {params});
    }

    

    buscarClientePorEmpresaECpf(empresaId?: number, cpf?: string): Observable<Cliente> {
        return this.http.get<Cliente>(this.url + 'empresa/' + empresaId + '/cpf/' + cpf);
    }

    salvar(cliente: Cliente): Observable<Cliente> {
        return this.http.post<Cliente>(this.url, cliente);
    }

    atualizar(cliente?: Cliente, clienteId?: number): Observable<Cliente> {
        return this.http.put<Cliente>(this.url + clienteId, cliente);
    }

    atualizarCpfCliente(clienteId?: number, empresaId?: number, cpf?: string): Observable<Cliente> {
        let params = new HttpParams();
        if(empresaId)
            params = params.set('empresaId', empresaId);
        if(cpf)
            params = params.set('cpf', cpf);
        return this.http.put<Cliente>(this.url + clienteId + '/cpf', params);
    }

    excluir(clienteId: number): Observable<void> {
        return this.http.delete<void>(this.url + clienteId);
    }


}